import { AppShell } from '@app/ui';
import { Box, Button, Grid2 } from '@mui/material';
import { useEffect, useState } from 'react';

function Content() {
  return (
    <Box sx={{ p: 2, maxWidth: '800px', margin: 'auto', color: '#333' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '24px' }}>隐私政策</h1>
      <p style={{ textAlign: 'center', color: '#666', fontSize: '0.9em' }}>
        更新日期：2025年9月6日 | 生效日期：2025年9月6日
      </p>

      <p>
        欢迎使用北京惠省科技有限公司（以下简称"我们"）开发的"紧急呼救"应用！我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。本隐私政策将帮助您了解：
      </p>
      <ul>
        <li>我们如何收集和使用您的个人信息</li>
        <li>我们如何使用Cookie和同类技术</li>
        <li>我们如何共享、转让、公开披露您的个人信息</li>
        <li>我们如何保护您的个人信息</li>
        <li>您的权利</li>
        <li>我们如何处理儿童的个人信息</li>
        <li>您的个人信息如何在全球范围转移</li>
        <li>本政策如何更新</li>
        <li>如何联系我们</li>
      </ul>

      <h2 style={{ borderBottom: '1px solid #eee', paddingBottom: '8px', marginTop: '32px' }}>
        一、我们如何收集和使用您的个人信息
      </h2>
      <p>
        为实现本应用的核心功能，我们可能会在您使用我们的服务时，收集和使用您的下列个人信息。请您理解，为实现相应业务功能，我们需要您开启特定的访问权限。
      </p>

      <h3>1. 跌倒检测功能</h3>
      <p>
        <strong>目的与权限：</strong>用于检测您是否发生跌倒或撞击等紧急情况，以便及时向紧急联系人发出求助信号。
      </p>
      <p>
        <strong>权限：</strong>我们需要您授权"身体传感器"（BODY_SENSORS）权限。
      </p>
      <p>
        <strong>传感器使用详细说明：</strong>为了实现智能跌倒检测和紧急状态识别功能，我们需要读取设备的特定类型传感器列表，并持续访问以下传感器：
      </p>
      <ul>
        <li><strong>加速度传感器（ACCELEROMETER）</strong>：实时检测设备的运动加速度变化，识别突发的冲击和跌倒动作模式</li>
        <li><strong>陀螺仪传感器（GYROSCOPE）</strong>：实时检测设备的旋转速度和姿态变化，分析用户摔倒时的角度变化特征</li>
        <li><strong>重力传感器（GRAVITY）</strong>：检测重力方向变化，辅助判断用户是否从站立状态跌倒至地面</li>
        <li><strong>线性加速度传感器（LINEAR_ACCELERATION）</strong>：排除重力影响后的纯运动加速度，提高跌倒检测精度</li>
        <li><strong>方向传感器（ORIENTATION）</strong>：检测设备的方向角度，判断用户的姿态变化</li>
      </ul>
      <p>
        <strong>数据收集与处理方式：</strong>
      </p>
      <ul>
        <li>传感器数据仅在您启用跌倒检测功能时进行实时采集</li>
        <li>数据采集频率为每秒50次，确保及时检测到异常状态</li>
        <li>所有传感器数据均在设备本地通过算法处理，不会上传到服务器</li>
        <li>我们不会存储您的详细运动轨迹或传感器原始数据</li>
        <li>仅在算法判定发生跌倒等紧急情况时，才会触发后续的求助流程</li>
        <li>您可以随时在应用设置中关闭跌倒检测功能，停止传感器数据采集</li>
      </ul>
      <p>
        <strong>法律依据与用户权利：</strong>根据《个人信息保护法》相关规定，我们基于您的明确同意收集和处理传感器数据，用于保障您的人身安全。您有权随时撤回同意、查询数据处理情况或要求停止数据收集。
      </p>

      <h3>2. 精确地理位置</h3>
      <p>
        <strong>目的与权限：</strong>在您触发紧急求助或系统检测到跌倒时，向您的紧急联系人或救援方提供您的准确位置。
      </p>
      <p>
        <strong>权限：</strong>
        我们需要您授权"精确定位"（ACCESS_FINE_LOCATION）、"粗略定位"（ACCESS_COARSE_LOCATION）以及"后台定位"（ACCESS_BACKGROUND_LOCATION）权限。
      </p>
      <p>
        <strong>使用方式与场景：</strong>
      </p>
      <ul>
        <li><strong>前台定位：</strong>在您主动使用应用或触发紧急求助时获取当前位置</li>
        <li><strong>后台定位：</strong>仅在跌倒检测功能开启且检测到异常时，在后台获取位置以便及时求助</li>
        <li><strong>静默状态下的位置收集：</strong>当应用在后台运行且启用跌倒检测时，我们可能会在检测到紧急情况时自动获取您的位置信息，以便向紧急联系人提供准确的救援位置</li>
        <li>我们不会持续追踪或记录您的位置轨迹，仅在紧急情况下按需获取</li>
      </ul>

      <h3>3. 音视频通话</h3>
      <p>
        <strong>目的与权限：</strong>在紧急情况下，让您能与紧急联系人或接警中心进行实时音视频沟通。
      </p>
      <p>
        <strong>权限：</strong>我们需要您授权"摄像头"（CAMERA）和"麦克风"（RECORD_AUDIO）权限。
      </p>
      <p>
        <strong>使用方式：</strong>
        我们仅在您发起或接听音视频通话时访问这些设备。通话内容默认不会被存储，除非在特定紧急情况下，为留存证据并征得您的同意。
      </p>

      <h3>4. 存储权限</h3>
      <p>
        <strong>目的与权限：</strong>用于存储您的紧急联系人信息、应用设置和必要的日志文件。
      </p>
      <p>
        <strong>权限：</strong>我们需要您授权"读取/写入外部存储"（READ/WRITE_EXTERNAL_STORAGE）权限。
      </p>

      <h3>5. 设备信息收集说明</h3>
      <p>
        <strong>目的与权限：</strong>为了确保应用的正常运行、问题排查和服务优化，我们可能会收集部分设备信息。
      </p>
      <p>
        <strong>收集的设备信息包括：</strong>
      </p>
      <ul>
        <li><strong>设备标识信息：</strong>设备型号、操作系统版本、应用版本号</li>
        <li><strong>网络信息：</strong>网络类型、IP地址、WiFi状态（用于确保通讯稳定）</li>
        <li><strong>硬件信息：</strong>传感器类型列表、屏幕分辨率（用于功能适配）</li>
        <li><strong>软件信息：</strong>已安装应用列表（仅用于兼容性检测，不会上传详细信息）</li>
      </ul>
      <p>
        <strong>收集说明：</strong>这些信息主要用于应用兼容性检测、功能优化和故障排查，我们会严格按照最小必要原则收集，并在本地处理后仅上传必要的统计信息。
      </p>

      <p>
        <strong>重要承诺 - 我们不会收集的敏感信息：</strong>
      </p>
      <ul>
        <li>❌ <strong>通讯录联系人信息：</strong>我们不会读取或收集您的联系人列表</li>
        <li>❌ <strong>短信内容：</strong>我们不会访问或收集您的短信内容</li>
        <li>❌ <strong>设备IMEI号码：</strong>我们不会收集设备的IMEI等硬件标识符</li>
        <li>❌ <strong>设备MAC地址：</strong>我们不会收集设备的物理网卡地址</li>
        <li>❌ <strong>完整应用列表：</strong>我们不会上传您设备上的完整应用安装列表</li>
      </ul>
      <p>
        <strong>隐私保护措施：</strong>如果检测工具发现此类信息收集行为，可能来自第三方SDK的技术实现需要，我们会严格限制其用途，确保数据仅用于应用功能实现，绝不用于用户追踪或商业目的。
      </p>

      <h3>6. 后台运行与自启动权限</h3>
      <p>
        <strong>目的与权限：</strong>为了确保应用能够持续提供紧急救援服务，我们需要相关的后台运行权限。
      </p>
      <p>
        <strong>权限列表：</strong>
      </p>
      <ul>
        <li><strong>前台服务权限（FOREGROUND_SERVICE）：</strong>用于在后台持续运行传感器监控服务</li>
        <li><strong>系统弹窗权限（SYSTEM_ALERT_WINDOW）：</strong>在紧急情况下显示紧急求助界面</li>
        <li><strong>开机自启动权限（RECEIVE_BOOT_COMPLETED）：</strong>确保设备重启后应用能自动启动保护功能</li>
        <li><strong>唤醒设备权限（WAKE_LOCK）：</strong>在检测到紧急情况时唤醒设备屏幕</li>
        <li><strong>锁屏显示权限（USE_FULL_SCREEN_INTENT）：</strong>在设备锁屏状态下显示紧急求助界面</li>
      </ul>
      <p>
        <strong>自启动行为详细说明：</strong>
      </p>
      <ul>
        <li><strong>触发条件：</strong>仅在您同时满足以下条件时，应用才会在开机时自动启动：
          <ul>
            <li>您已在应用中开启"开机自启动"功能</li>
            <li>您已启用跌倒检测或其他紧急保护功能</li>
          </ul>
        </li>
        <li><strong>启动内容：</strong>应用仅启动必要的后台监控服务，不会自动打开应用界面</li>
        <li><strong>用户控制：</strong>
          <ul>
            <li>首次启用保护功能时，我们会通过弹窗明确告知您自启动功能的用途</li>
            <li>您可以选择是否开启"开机自启动"功能</li>
            <li>您可以在应用设置中随时开启或关闭"开机自启动"功能</li>
            <li>关闭自启动后，设备重启时应用不会自动启动，但您可以手动启动应用</li>
          </ul>
        </li>
        <li><strong>使用目的：</strong>自启动的唯一目的是确保跌倒检测等安全功能能够持续工作，保护您的人身安全</li>
        {/* <li><strong>隐私承诺：</strong>我们承诺不会因为营销、广告推送或其他非安全目的进行自启动</li> */}
      </ul>
      <p>
        <strong>如何管理自启动功能：</strong>
      </p>
      <ul>
        <li>在应用内：首次启用保护功能时会询问您是否开启自启动，您也可以在设置中随时修改</li>
        <li>在系统设置中：部分手机厂商提供了自启动管理功能，您也可以在系统设置中管理应用的自启动权限</li>
      </ul>

      <h2 style={{ borderBottom: '1px solid #eee', paddingBottom: '8px', marginTop: '32px' }}>
        二、我们如何使用Cookie和同类技术
      </h2>
      <p>
        我们使用Cookie和类似技术来提供、保护和分析我们的服务。这些技术帮助我们理解您如何使用我们的服务，以便我们改进服务质量。
      </p>
      <h2 style={{ borderBottom: '1px solid #eee', paddingBottom: '8px', marginTop: '32px' }}>三、第三方SDK声明</h2>
      <p>
        为了保障应用的正常运行及实现特定功能，本应用集成了以下第三方SDK。我们严格按照《个人信息保护法》《网络安全法》等相关法律法规，明确告知您这些SDK的基本信息。
      </p>

      <h3>1. 高德定位SDK</h3>
      <ul>
        <li><strong>SDK名称：</strong>高德定位SDK</li>
        <li><strong>开发者：</strong>高德软件有限公司</li>
        <li><strong>收集信息范围：</strong>精确位置信息、粗略位置信息、WIFI扫描结果</li>
        <li><strong>目的：</strong>为用户提供精准定位服务，用于紧急求助时定位用户位置</li>
        <li><strong>SDK隐私政策链接：</strong><a href="https://lbs.amap.com/pages/privacy/" target="_blank" rel="noopener noreferrer">https://lbs.amap.com/pages/privacy/</a></li>
      </ul>

      <h3>2. 极光推送SDK</h3>
      <ul>
        <li><strong>SDK名称：</strong>极光推送SDK</li>
        <li><strong>开发者：</strong>深圳市和讯华谷信息技术有限公司</li>
        <li><strong>收集信息范围：</strong>设备信息（MAC地址、设备标识符）、软件安装列表、网络信息、位置信息</li>
        <li><strong>目的：</strong>为用户提供及时、稳定的消息推送服务</li>
        <li><strong>SDK隐私政策链接：</strong><a href="https://www.jiguang.cn/license/privacy" target="_blank" rel="noopener noreferrer">https://www.jiguang.cn/license/privacy</a></li>
      </ul>

      <h3>3. Google服务SDK</h3>
      <ul>
        <li><strong>SDK名称：</strong>GoogleLocation、GoogleAccountLogin、GoogleProtobuf</li>
        <li><strong>开发者：</strong>Google LLC</li>
        <li><strong>收集信息范围：</strong>位置信息、账户信息（仅在使用Google登录时）</li>
        <li><strong>目的：</strong>提供Google服务集成，包括位置服务和账户登录功能</li>
        <li><strong>SDK隐私政策链接：</strong><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a></li>
      </ul>

      <h3>4. Twilio通讯SDK</h3>
      <ul>
        <li><strong>SDK名称：</strong>Twilio</li>
        <li><strong>开发者：</strong>Twilio公司</li>
        <li><strong>收集信息范围：</strong>蓝牙信息（用于音视频通话）</li>
        <li><strong>目的：</strong>提供音视频通话服务，支持紧急情况下的实时通讯</li>
        <li><strong>SDK隐私政策链接：</strong><a href="https://www.twilio.com/legal/privacy" target="_blank" rel="noopener noreferrer">https://www.twilio.com/legal/privacy</a></li>
      </ul>

      <h3>5. 基础功能SDK</h3>
      <p>本应用还集成了以下基础功能SDK，用于提供基础的网络请求、数据解析、日志记录等功能：</p>
      <ul>
        <li><strong>网络请求类：</strong>Okhttp3、ApacheHttp - 用于网络数据传输</li>
        <li><strong>数据处理类：</strong>谷歌Gson、FasterXMLJackson - 用于JSON数据解析</li>
        <li><strong>日志记录类：</strong>Timber - 用于应用运行日志记录</li>
        <li><strong>其他工具类：</strong>EventBus、JodaTime、Okio等 - 用于应用内部功能实现</li>
      </ul>
      <p>这些基础SDK主要处理技术实现层面的功能，不会收集您的个人敏感信息。</p>

      <h3>6. SDK隐私合规管理</h3>
      <p>
        <strong>第三方SDK数据处理管理原则：</strong>
      </p>
      <ul>
        <li><strong>隐私政策优先：</strong>所有第三方SDK只有在您同意本隐私政策后才会初始化和运行</li>
        <li><strong>权限严格控制：</strong>我们严格限制第三方SDK的数据收集范围和使用用途</li>
        <li><strong>定期安全审查：</strong>定期审查和更新SDK版本以确保持续的隐私合规性</li>
        <li><strong>违规处理机制：</strong>如发现SDK存在违规收集行为，会立即修复或移除该SDK</li>
      </ul>
      <p>
        <strong>极光推送SDK特别说明：</strong>
      </p>
      <ul>
        <li>只有在您明确同意隐私政策后，极光推送服务才会启动</li>
        <li>设备信息收集仅限于推送消息的正常送达功能</li>
        <li>您可以在系统设置中随时关闭推送通知功能</li>
        <li>我们不会将推送相关的设备信息用于用户画像或精准营销</li>
      </ul>

      <p>
        <strong>重要提示：</strong>您可以根据个人意愿选择是否允许这些SDK收集您的信息，但拒绝相关权限可能会影响应用的部分功能，如定位服务和消息推送。我们承诺所有SDK的使用都严格遵循最小必要原则，仅收集实现相应功能所必需的信息。
      </p>

      <h2 style={{ borderBottom: '1px solid #eee', paddingBottom: '8px', marginTop: '32px' }}>
        四、我们如何共享、转让、公开披露您的个人信息
      </h2>
      <p>我们不会与任何第三方共享您的个人信息，除非是为实现核心求助目的，例如：</p>
      <ul>
        <li>
          <strong>向您的紧急联系人：</strong>
          在您求助或系统检测到紧急情况时，我们会将您的实时位置、求助信息等共享给您指定的紧急联系人。
        </li>
        <li>
          <strong>向公共安全机构：</strong>
          在必要时，我们可能会根据法律法规要求，向警察、消防、医疗等公共安全或救援机构提供您的信息。
        </li>
        <li>
          <strong>在获取您明确同意的情况下。</strong>
        </li>
      </ul>

      <h2 style={{ borderBottom: '1px solid #eee', paddingBottom: '8px', marginTop: '32px' }}>
        五、我们如何保护您的个人信息
      </h2>
      <p>我们已采取符合业界标准的安全防护措施保护您的个人信息，包括但不限于：</p>
      <ul>
        <li>使用加密技术确保数据在传输和存储过程中的安全</li>
        <li>建立严格的数据访问权限控制机制</li>
        <li>定期进行安全审计和风险评估</li>
      </ul>
      <p>您的个人数据将存储在中国境内的服务器上，存储期限为2年，除非法律法规另有规定。</p>

      <h2 style={{ borderBottom: '1px solid #eee', paddingBottom: '8px', marginTop: '32px' }}>六、您的权利</h2>
      <p>按照中国相关法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</p>
      <ul>
        <li>
          <strong>访问权：</strong>您有权访问您的个人信息
        </li>
        <li>
          <strong>更正权：</strong>您有权更正或补充您的个人信息
        </li>
        <li>
          <strong>删除权：</strong>在特定情形下，您可以要求我们删除您的个人信息
        </li>
        <li>
          <strong>撤回同意权：</strong>您有权撤回已同意的授权
        </li>
        <li>
          <strong>注销权：</strong>您可以在应用设置中提交账号注销申请
        </li>
      </ul>

      <h2 style={{ borderBottom: '1px solid #eee', paddingBottom: '8px', marginTop: '32px' }}>
        七、我们如何处理儿童的个人信息
      </h2>
      <p>我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不应创建自己的个人信息主体账户。</p>
      <p>
        对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。
      </p>

      <h2 style={{ borderBottom: '1px solid #eee', paddingBottom: '8px', marginTop: '32px' }}>八、本政策如何更新</h2>
      <p>
        我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。
      </p>
      <p>
        对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件发送通知，说明隐私政策的具体变更内容）。
      </p>

      <h2 style={{ borderBottom: '1px solid #eee', paddingBottom: '8px', marginTop: '32px' }}>九、如何联系我们</h2>
      <p>如果您对本隐私政策有任何疑问、意见或建议，请通过以下方式与我们联系：</p>
      <p>公司名称：北京惠省科技有限公司</p>
      <p>联系邮箱：fanfanlo@outlook.com</p>
      <p>我们将在收到您的问题、意见或建议后15个工作日内回复您的请求。</p>
    </Box>
  );
}

function Buttons() {
  function sendMessage(agree: boolean) {
    if (!window.parent) return;
    window.parent.postMessage({ sender: 'privacy_page', agree }, '*');
  }
  function onDisagree() {
    sendMessage(false);
  }
  function onAgree() {
    sendMessage(true);
  }
  return (
    <Grid2 container spacing={2}>
      <Grid2 size={6} sx={{ textAlign: 'center' }}>
        <Button onClick={onDisagree}>不同意</Button>
      </Grid2>
      <Grid2 size={6} sx={{ textAlign: 'center' }}>
        <Button onClick={onAgree} variant="contained">
          同意
        </Button>
      </Grid2>
    </Grid2>
  );
}

export default function PrivacyPageZhCn() {
  const [isIframe, setIsIframe] = useState(false);
  
  useEffect(() => {
    console.log('urlsi', window.location.href)
    const isIframe = window.self !== window.top;
    setIsIframe(isIframe);
    console.log('isIframe=', isIframe);
  }, []);
  return (
    <Box sx={{ pb: isIframe ? '80px' : 0 }}>
      <Content />
      {isIframe && (
        <Box
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            p: 2,
            bgcolor: 'background.paper',
            boxShadow: '0 -2px 5px rgba(0,0,0,0.1)',
            zIndex: 1000,
          }}>
          <Buttons />
        </Box>
      )}
    </Box>
  );
}
